import { lazy, Suspense } from "react";
import { Outlet, Navigate, useRoutes } from "react-router-dom";

import DashboardLayout from "../layouts/dashboard";
import Loader from "../components/loader/Loader";
import HotelPage from "../pages/hotel";
import BranchPage from "../pages/branch";
// Lazy load pages
export const IndexPage = lazy(() => import("../pages/app"));
export const BlogPage = lazy(() => import("../pages/blog"));
export const TablePage = lazy(() => import("../pages/table"));
export const OrdersChefPage = lazy(() => import("../pages/ordersChefPage"));
export const FoodPage = lazy(() => import("../pages/food"));
export const Category = lazy(() => import("../pages/category"));
export const Inventorymenu = lazy(() => import("../pages/Inventory"));
export const UserPage = lazy(() => import("../pages/user"));
export const LoginPage = lazy(() => import("../pages/login"));
export const RegisterPage = lazy(() => import("../pages/register"));
export const ProductsPage = lazy(() => import("../pages/products"));
export const PaymentListPage = lazy(() => import("../pages/paymentlist"));
export const Page404 = lazy(() => import("../pages/page-not-found"));
export const Settings = lazy(() => import("../pages/Settings"));
export const ReportMenu = lazy(() => import("../pages/Reports"));
export const Invoices = lazy(() => import("../pages/Invoices"));
export const Forgetpassword = lazy(() => import("../pages/forgetpassword"));
export const Waiters = lazy(() => import("../pages/waiters"));
export const Kitchen = lazy(() => import("../pages/Kitchen"));
const isAuthenticated = () => {
  return localStorage.getItem("token");
};

function ProtectedRoute({ children }) {
  return isAuthenticated() ? children : <Navigate to="/login" replace />;
}

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      element: (
        <DashboardLayout>
          <Suspense fallback={<Loader />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      ),
      children: [
        {
          element: (
            <ProtectedRoute>
              <IndexPage />
            </ProtectedRoute>
          ),
          index: true,
        },
        {
          path: "table",
          element: (
            <ProtectedRoute>
              <TablePage />
            </ProtectedRoute>
          ),
        },
        {
          path: "order",
          element: (
            <ProtectedRoute>
              <OrdersChefPage />
            </ProtectedRoute>
          ),
        },
        {
          path: "user",
          element: (
            <ProtectedRoute>
              <UserPage />
            </ProtectedRoute>
          ),
        },
        {
          path: "food",
          element: (
            <ProtectedRoute>
              <FoodPage />
            </ProtectedRoute>
          ),
        },
        {
          path: "category",
          element: (
            <ProtectedRoute>
              <Category />
            </ProtectedRoute>
          ),
        },
        {
          path: "inventory-management",
          element: (
            <ProtectedRoute>
              <Inventorymenu />
            </ProtectedRoute>
          ),
        },
        {
          path: "Settings/:tab?",
          element: (
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          ),
        },
        {
          path: "/Report",
          element: (
            <ProtectedRoute>
              <ReportMenu />
            </ProtectedRoute>
          ),
        },
        {
          path: "Invoices",
          element: (
            <ProtectedRoute>
              <Invoices />
            </ProtectedRoute>
          ),
        },
        {
          path: "products",
          element: (
            <ProtectedRoute>
              <ProductsPage />
            </ProtectedRoute>
          ),
        },
        {
          path: "blog",
          element: (
            <ProtectedRoute>
              <BlogPage />
            </ProtectedRoute>
          ),
        },
        {
          path: "payment",
          element: (
            <ProtectedRoute>
              <PaymentListPage />
            </ProtectedRoute>
          ),
        },
        {
          path: "hotel",
          element: (
            <ProtectedRoute>
              <HotelPage />
            </ProtectedRoute>
          ),
        },
        {
          path: "branch",
          element: (
            <ProtectedRoute>
              <BranchPage />
            </ProtectedRoute>
          ),
        },
        {
          path: "waiters",
          element: (
            <ProtectedRoute>
              <Waiters />
            </ProtectedRoute>
          ),
        },
        {
          path: "Kitchen",
          element: (
            <ProtectedRoute>
              <Kitchen />
            </ProtectedRoute>
          ),
        },
      ],
    },
    {
      path: "login",
      element: <LoginPage />,
    },
    {
      path: "signup",
      element: <RegisterPage />,
    },
    {
      path: "forget-password",
      element: <Forgetpassword />,
    },
    {
      path: "404",
      element: <Page404 />,
    },
    {
      path: "*",
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
